export * from "./SportConfig";